export const API_PREFIX = '/api/v1';

export const WRONG_USER_OR_PASSWORD = 'E-mail și/sau parola sunt incorecte';

export const UNAUTHORIZED_STATUS_CODE = 401;
